import { render, staticRenderFns } from "./HomepageView.vue?vue&type=template&id=10918797&"
import script from "./HomepageView.vue?vue&type=script&lang=ts&"
export * from "./HomepageView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports